// extracted by mini-css-extract-plugin
export var askAiIcon = "_m2-j";
export var category = "_m2-9";
export var categoryHeader = "_m2-e";
export var container = "_m2-0";
export var group = "_m2-a";
export var groupItems = "_m2-f";
export var groupSeparator = "_m2-k";
export var loading = "_m2-1";
export var noResults = "_m2-3";
export var placeholder = "_m2-2";
export var resultContent = "_m2-5";
export var resultIcon = "_m2-c";
export var resultItem = "_m2-g";
export var resultMeta = "_m2-8";
export var resultSubtitle = "_m2-7";
export var resultSuffix = "_m2-i";
export var resultTitle = "_m2-6";
export var resultsList = "_m2-4";
export var searchGroup = "_m2-d";
export var selected = "_m2-h";
export var subgroup = "_m2-b";